/*  This file can be replicated for the majority of CRUD logic for each model. */

import HTTP from "../../system/utils/Http";
import { notify } from "reapop";
import {
  fetchAllStart,
  fetchAllSuccess,
  fetchAllError,
  fetchStart,
  fetchSuccess,
  fetchError,
  updateStart,
  updateSuccess,
  updateError,
  deleteStart,
  deleteSuccess,
  deleteError,
  createStart,
  createSuccess,
  createError
} from "./actions";

/* Assign the endpoint URL here */
const endpoint = `/cruiseline-details/`;

export const actionCreators = {
  fetchAll() {
    return dispatch => {
      dispatch(fetchAllStart());
      HTTP.get(endpoint)
        .then(res => {
          dispatch(fetchAllSuccess(res.data));
        })
        .catch(err => {
          dispatch(fetchAllError(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
          dispatch(
            notify({ message: "Could not load entries", status: "error" })
          );
        });
    };
  },

  fetch(id) {
    return dispatch => {
      dispatch(fetchStart());
      HTTP.get(endpoint)
        .then(res => {
          dispatch(fetchSuccess(res));
        })
        .catch(err => {
          dispatch(fetchError(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
          dispatch(
            notify({ message: "Could not load entry", status: "error" })
          );
        });
    };
  },

  update(data, values) {
    return dispatch => {
      
      HTTP.put(endpoint + 1, {
        name: values.data.data.name,
        description: values.data.data.description,
        summary: values.data.data.summary,
        banner_image: values.data.data.banner_image
      })
        .then(res => {
          dispatch(createSuccess());
          dispatch(
            notify({ message: "Entry created successfully", status: "success" })
          );
        })
        .catch(err => {
          dispatch(createError(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
          dispatch(
            notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" })
          );
        });
    };
  },

  // update(id, data) {
  //   return dispatch => {
      
  //     HTTP.put(endpoint + 1, data)
  //       .then(res => {
  //         dispatch(updateSuccess(data));
  //         dispatch(
  //           notify({ message: "Entry saved successfully", status: "success" })
  //         );
  //       })
  //       .catch(err => {
  //         dispatch(updateError(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
  //         dispatch(notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" }));
  //       });
  //   };
  // },

  delete(entries) {
    return dispatch => {
      dispatch(deleteStart());
      HTTP({ method: "delete", url: endpoint, data: { id: entries } })
        .then(res => {
          window.location.href = '/cruiseline-page';
          dispatch(deleteSuccess());
          dispatch(
            notify({
              message: "Entry(s) deleted successfully",
              status: "success"
            })
          );
        })
        .catch(err => {
          dispatch(deleteError(err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message));
          dispatch(
            notify({ message: err.response.data.message !== null && err.response.data.message !== undefined ? err.response.data.message : err.response.data.error.message, status: "error" })
          );
        });
    };
  }
};



// WEBPACK FOOTER //
// ./src/store/cruiselinePage/index.js